const prefix = 'user-details-common-info';

const SET_USER_NAME = `${prefix}/SET_USER_NAME`;

// eslint-disable-next-line import/prefer-default-export
export { SET_USER_NAME };
